export default function permissionsMatch(options) {
  const { required = [], oneOf = [], permissions = [] } = options;
  return !!(
    required.every(scope => permissions.includes(scope)) &&
    (!oneOf.length || oneOf.find(scope => permissions.includes(scope)))
  );
}
